import {withGrayTransparency} from "../../../../hocs/withGrayTransparency";
import {withCapitalized} from "../../../../hocs/withCapitalized";
import {CardItemValue} from "../CardItemValue";

export const CardItemValueWithGrayCapitalized = withCapitalized(withGrayTransparency(CardItemValue));
